import React, { useState } from 'react';
import { Alert, Form, Select } from '@bancobarigui/barihaus';

import { ReportsContainer, ReportsFormWrapper, ReportAlertWrapper } from './styles';
import ReportNMP from './ReportNMP';

type ReportType = 'npm';
type AlertStatus = 'success' | 'error' | null;

const reportTypeOptions: { label: string; value: ReportType; disabled: boolean }[] = [
  { label: 'Relatório NMP (Não me perturbe)', value: 'npm', disabled: false },
];

interface ReportComponentProps {
  onAlertChange: (status: AlertStatus) => void;
}

const reportComponents: Record<ReportType, React.FC<ReportComponentProps>> = {
  npm: ReportNMP,
};

const Reports: React.FC = () => {
  const [form] = Form.useForm();
  const [selectedReport, setSelectedReport] = useState<ReportType | null>(null);
  const [alertStatus, setAlertStatus] = useState<AlertStatus>(null);

  const ReportFields = selectedReport ? reportComponents[selectedReport] : null;

  return (
    <ReportsContainer>
      <h1>Relatórios</h1>
      {alertStatus === 'success' && (
        <ReportAlertWrapper>
          <Alert
            type="success"
            title="Relatório gerado com sucesso!"
            closable={true}
            showIcon={true}
          />
        </ReportAlertWrapper>
      )}
      {alertStatus === 'error' && (
        <ReportAlertWrapper>
          <Alert 
            type="error"
            title="Erro ao gerar relatório!" 
            showIcon={true}
            closable={true}
          />
        </ReportAlertWrapper>
      )}
      <ReportsFormWrapper>
        <Form form={form} layout="vertical" requiredMark={false}>
          <Form.Item label="Tipo de relatório" name="reportType">
            <Select
              placeholder="Selecione"
              disabled={false}
              options={reportTypeOptions}
              onChange={(value) => {
                setSelectedReport(value as ReportType);
                setAlertStatus(null);
                form.resetFields(['period']);
              }}
            />
          </Form.Item>
          {ReportFields && <ReportFields onAlertChange={setAlertStatus} />}
        </Form>
      </ReportsFormWrapper>
    </ReportsContainer>
  );
};

export default Reports;
